const PHARMACY_LOCAL_DRAFT_KEYS = [
    'pharmacy_counters',
    'pharmacy_selected_customer'
];

const PHARMACY_SESSION_DRAFT_KEYS = [
    'pharmacyEditSaleId',
    'pharmacyEditStockEntryId'
];

const PHARMACY_DRAFT_QUERY_KEYS = [
    'editSale',
    'editStockIn'
];

export const clearPharmacyDraftState = () => {
    try {
        PHARMACY_LOCAL_DRAFT_KEYS.forEach((key) => localStorage.removeItem(key));
    } catch (e) {}

    try {
        PHARMACY_SESSION_DRAFT_KEYS.forEach((key) => sessionStorage.removeItem(key));
    } catch (e) {}

    try {
        if (typeof window === 'undefined' || typeof window.history?.replaceState !== 'function') return;

        const url = new URL(window.location.href);
        let changed = false;

        PHARMACY_DRAFT_QUERY_KEYS.forEach((key) => {
            if (url.searchParams.has(key)) {
                url.searchParams.delete(key);
                changed = true;
            }
        });

        if (changed) {
            window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
        }
    } catch (e) {}
};